import React from "react";
export default function LatLngToAddress({ lat, lng }) {
  return (
    <ul>
      <li>
        <p>
          <a href="mailto:support@qiktruck.co.za">support@qiktruck.co.za</a>
        </p>
      </li>
      <li>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="tel:+27712433386">
            Calls
          </a>
        </p>
      </li>
      <li>
        <p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://wa.me/+27663784460"
          >
            Messages
          </a>
        </p>
      </li>

      <li>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="tel:+27715465244">
            Vehicle Inspections
          </a>
        </p>
      </li>
    </ul>
  );
}
